import mutations from './mutations'
import getters from './getters'
import actions from './actions'

export const initialState = () => ({
  'domain_id': null,
  'domainPopulated': false,
  'domainCache': [],
  'domainQueue': [],
  domainsTransferList: [],
  // domain change requests:
  domainChangeRequests: [],
  domainChangeInterval: null,
})

export const state = initialState

const module = {
  state,
  getters,
  mutations,
  actions
}

export default module
